import AssistancePage from './AssistancePage';

export default AssistancePage;
